var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGoTop(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Gotop",
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_51932",
    "data-name": "Group 51932",
    transform: "translate(-944.856 -5243.356)",
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4928",
    "data-name": "Rectangle 4928",
    width: 40,
    height: 40,
    rx: 4,
    transform: "translate(944.856 5243.356)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-chevron-up",
    "data-name": "Icon awesome-chevron-up",
    d: "M974.866,5265.783l11.572,11.732a1.464,1.464,0,0,1,0,2.05l-1.35,1.369a1.417,1.417,0,0,1-2.018,0l-9.212-9.3-9.215,9.3a1.415,1.415,0,0,1-2.018,0l-1.349-1.371a1.465,1.465,0,0,1,0-2.05l11.571-11.732A1.414,1.414,0,0,1,974.866,5265.783Z",
    transform: "translate(-9 -10.002)",
    fill: "#232323"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoTop);
export default __webpack_public_path__ + "static/media/go_top.da82827706bd8432d49ac9f7b3737bc0.svg";
export { ForwardRef as ReactComponent };